import axios from "../../../axios/axiosSetup";
import { BASE_URL } from "../../../configs/WebServiceUrl";

const BASE = `${BASE_URL}/lms/online-exam`;

export const oeGetExamInfo            = (examId, params)       => axios.get(`${BASE}/${examId}`, { params });
export const oeStartExam              = (examId, data)         => axios.post(`${BASE}/${examId}/start`, data);
export const oeGetExamAttempts        = (examId, params)       => axios.get(`${BASE}/${examId}/attempts`, { params });
export const oeToggleResultVisibility = (examId, data)         => axios.patch(`${BASE}/${examId}/result-visibility`, data);

export const oeSaveAnswer             = (attemptId, data)      => axios.post(`${BASE}/attempts/${attemptId}/answer`, data);
export const oeSubmitExam             = (attemptId, data)      => axios.post(`${BASE}/attempts/${attemptId}/submit`, data);
export const oeGetResult              = (attemptId)            => axios.get(`${BASE}/attempts/${attemptId}/result`);
export const oeGetAttemptDetail       = (attemptId)            => axios.get(`${BASE}/attempts/${attemptId}`);
export const oeLogViolation           = (attemptId)            => axios.patch(`${BASE}/attempts/${attemptId}/violation`);
export const oeRecalculateAttempt    = (attemptId)            => axios.post(`${BASE}/attempts/${attemptId}/recalculate`);

export const oeGradeAnswer            = (answerId, data)       => axios.put(`${BASE}/answers/${answerId}/grade`, data);
